document.addEventListener('DOMContentLoaded', function() {
    // Initialize search functionality for both desktop and mobile
    function initializeSearch(isMobile) {
        const suffix = isMobile ? '-mobile' : '';
        const searchTrigger = document.getElementById(`simcornerSearchTrigger${suffix}`);
        const searchModal = document.getElementById(`simcornerSearchModal${suffix}`);
        const searchClose = document.getElementById(`simcornerSearchClose${suffix}`);
        const searchInput = document.getElementById(`simcornerSearchInput${suffix}`);
        const searchResults = document.getElementById(`simcornerSearchResults${suffix}`);
        
        // If elements don't exist for this version (mobile/desktop), return early
        if (!searchTrigger || !searchModal || !searchClose || !searchInput || !searchResults) {
            return;
        }

        const searchOverlay = searchModal.querySelector('.simcorner-search-modal__overlay');
        let searchTimeout;

        function openSearchModal() {
            searchModal.classList.add('active');
            searchInput.focus();
            document.body.style.overflow = 'hidden';
        }

        function closeSearchModal() {
            searchModal.classList.remove('active');
            document.body.style.overflow = '';
            searchInput.value = '';
            searchResults.innerHTML = '';
        }

        function performSearch(query) {
            if (query.length < 2) {
                searchResults.innerHTML = '';
                return;
            }

            // Show loading state
            searchResults.innerHTML = '<div class="simcorner-search-loading">Searching...</div>';

            // Fetch both predictive search results and products.json for comprehensive search
            const suggestPromise = fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article`)
                .then(response => response.json())
                .catch(() => ({ resources: { results: {} } }));

            const productsPromise = fetch(`/products.json?limit=250`)
                .then(response => response.json())
                .then(data => {
                    // Filter products that match the search query in title, body, or tags
                    const searchLower = query.toLowerCase();
                    return data.products.filter(product => {
                        return product.title.toLowerCase().includes(searchLower) ||
                               (product.body_html && product.body_html.toLowerCase().includes(searchLower)) ||
                               product.tags.some(tag => tag.toLowerCase().includes(searchLower)) ||
                               product.product_type.toLowerCase().includes(searchLower) ||
                               product.vendor.toLowerCase().includes(searchLower);
                    });
                })
                .catch(() => []);

            Promise.all([suggestPromise, productsPromise])
                .then(([suggestData, filteredProducts]) => {
                    const suggestProducts = suggestData.resources.results.products || [];
                    const collections = suggestData.resources.results.collections || [];
                    const pages = suggestData.resources.results.pages || [];
                    const articles = suggestData.resources.results.articles || [];
                    
                    // Combine and deduplicate products
                    const allProductsMap = new Map();
                    
                    // Add suggest products first
                    suggestProducts.forEach(product => {
                        allProductsMap.set(product.id, {
                            ...product,
                            body: product.body || (product.body_html ? product.body_html.replace(/<[^>]*>/g, '') : '')
                        });
                    });
                    
                    // Add filtered products from products.json
                    filteredProducts.forEach(product => {
                        if (!allProductsMap.has(product.id)) {
                            allProductsMap.set(product.id, {
                                id: product.id,
                                title: product.title,
                                handle: product.handle,
                                body: product.body_html ? product.body_html.replace(/<[^>]*>/g, '') : '',
                                featured_image: product.images && product.images.length > 0 ? 
                                    { url: product.images[0].src } : null
                            });
                        }
                    });
                    
                    const products = Array.from(allProductsMap.values()).slice(0, 10); // Limit to 10 results

                    let resultsHTML = '';

                    // Add products section if there are products
                    if (products.length > 0) {
                        resultsHTML += `
                            <div class="simcorner-search-section">
                                <h3 class="simcorner-search-section-title">Products</h3>
                                ${products.map(product => `
                                    <a href="/products/${product.handle}" class="simcorner-search-result-item">
                                        <div class="simcorner-search-result-content">
                                            ${product.featured_image ? `
                                                <div class="simcorner-search-result-image">
                                                    <img src="${product.featured_image.url}" alt="${product.title}" loading="lazy">
                                                </div>
                                            ` : `
                                                <div class="simcorner-search-result-image simcorner-search-result-image--placeholder">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                                                        <circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" stroke-width="2"/>
                                                        <polyline points="21,15 16,10 5,21" stroke="currentColor" stroke-width="2"/>
                                                    </svg>
                                                </div>
                                            `}
                                            <div class="simcorner-search-result-info">
                                                <div class="simcorner-search-result-title">${product.title}</div>
                                            </div>
                                        </div>
                                    </a>
                                `).join('')}
                            </div>
                        `;
                    }

                    // Add collections section if there are collections
                    if (collections.length > 0) {
                        resultsHTML += `
                            <div class="simcorner-search-section">
                                <h3 class="simcorner-search-section-title">Collections</h3>
                                ${collections.map(collection => `
                                    <a href="/collections/${collection.handle}" class="simcorner-search-result-item">
                                        <div class="simcorner-search-result-title">${collection.title}</div>
                                    </a>
                                `).join('')}
                            </div>
                        `;
                    }

                    // If no results found
                    if (!resultsHTML) {
                        resultsHTML = '<div class="simcorner-search-no-results">No results found</div>';
                    }

                    // Update the results container
                    searchResults.innerHTML = resultsHTML;
                })
                .catch(error => {
                    console.error('Search error:', error);
                    searchResults.innerHTML = '<div class="simcorner-search-error">An error occurred while searching</div>';
                });
        }

        // Event Listeners
        searchTrigger.addEventListener('click', openSearchModal);
        searchClose.addEventListener('click', closeSearchModal);
        searchOverlay.addEventListener('click', closeSearchModal);

        // Close on escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && searchModal.classList.contains('active')) {
                closeSearchModal();
            }
        });

        // Handle search input with debounce
        searchInput.addEventListener('input', function(e) {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                performSearch(e.target.value.trim());
            }, 300);
        });
    }

    // Initialize both desktop and mobile search
    initializeSearch(false); // Desktop
    initializeSearch(true);  // Mobile
});